module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [(_vm.$slots.left) ? _c('div', {
    staticClass: "nav-left"
  }, [_vm._t("left")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.center) ? _c('div', {
    staticClass: "nav-center"
  }, [_vm._t("center")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.right) ? _c('span', {
    staticClass: "nav-toggle",
    class: {
      'is-active': _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.isActive = !_vm.isActive
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), (_vm.$slots.right) ? _c('div', {
    staticClass: "nav-right nav-menu",
    class: {
      'is-active': _vm.isActive
    }
  }, [_vm._t("right")], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fea0f456"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 287
// module chunks = 1